// eslint-disable-next-line max-lines
import jquery from 'jquery';
import _Singleton from '@/tools/singleton';
import ajaxShop from '@/ajax/shop/';
import Shop from '@/shop';
import renderRecaptchaWidgetOnVisible from '@/google-recaptcha/renderRecaptchaWidgetOnVisible';
import renderYandexCaptchaWidgetOnVisible from '@/yandex-captcha/renderCaptchaWidgetOnVisible';
import getCaptchaMessageData from '@/helpers/getCaptchaMessageData';
import resetCaptcha from '@/helpers/resetCaptcha';

import options from '@/ui/ui_feedback/default-selectors.json';
import settings from '@/ui/ui_feedback/default-settings.json';

import { CAPTCHA_TYPE_GOOGLE, CAPTCHA_TYPE_YANDEX } from '@/constants';

/**
 * @class
 * @private
 *
 * @description
 * DOM + Feedback
 */
const FeedbackDOM = function() {
  const self = this;

  document.addEventListener('DOMContentLoaded', function() {
    self._init();
  });
};

/**
 * Инициализация
 * @method
 * @private
 *
 * @returns {void}
 */
FeedbackDOM.prototype._init = function() {
  const self = this;

  self.options = options;
  self.settings = settings;
  self.locale = Shop.config.config.locale;
  self.captchaType = Shop.config.config.captcha_type;
  self.sending = false;

  self._bindSendFeedbackForm();
  self._bindFeedbackFormFieldActions();
  self._checkRequiredFields();
  self._bindAgreeActions();
  self._bindShowFeedbackModalForm();

  if (self.captchaType === CAPTCHA_TYPE_YANDEX) {
    self._bindYandexCaptchaActions();

    document.querySelectorAll(self.options.formYandexCaptcha.attr).forEach(captchaBlock => {
      renderYandexCaptchaWidgetOnVisible({
        context: self,
        captchaBlock,
        formType: 'feedback'
      });
    });
  }

  if (self.captchaType === CAPTCHA_TYPE_GOOGLE) {
    self._bindRecaptchaActions();

    document.querySelectorAll(self.options.formRecaptcha.attr).forEach(recaptchaBlock => {
      renderRecaptchaWidgetOnVisible(self, recaptchaBlock, 'feedback');
    });
  }
};

/**
 * Обработчик отправки формы
 * @method
 * @private
 *
 * @returns {void}
 */
FeedbackDOM.prototype._bindSendFeedbackForm = function() {
  const self = this;

  jquery(document).on('submit', self.options.form.attr, function(event) {
    event.preventDefault();

    self._sendFeedbackForm(jquery(this));
  });
};

/**
* Отправка формы
* @method
* @private
* @param {Object} form - форма
* @returns {void}
*/
FeedbackDOM.prototype._sendFeedbackForm = function(form) {
  const self = this;
  const $form = jquery(form);
  const successBlock = $form.find(self.options.formSuccess.attr);
  const fieldAgree = $form.find(self.options.formFieldAgree.attr);
  const eventData = { form: $form };

  // Получаем данные и статус капчи
  const captchaResult = getCaptchaMessageData({
    captchaType: this.captchaType,
    form: $form.get(0),
    fieldRecaptcha: $form.find(self.options.formRecaptcha.attr).get(0),
    fieldYandexCaptcha: $form.find(self.options.formYandexCaptcha.attr).get(0),
    formType: 'feedback',
    callback: self._sendFeedbackForm.bind(self)
  });

  if (captchaResult.status === 'pending') {
    return;
  }

  // Валидация формы
  const errors = self._validateForm($form);

  if (Object.values(errors).length !== 0) {
    console.warn('Форма заполнена некорректно', errors);
    window.EventBus.publish('break-send-feedback:insales:ui_feedback', {
      ...eventData,
      errors
    });

    return false;
  }

  // Новый хук: подписчики могут дописать что-то в поля формы (например, content),
  // а ниже значения будут считаны через .val()
  window.EventBus.publish('before-feedback-message-build:insales:ui_feedback', eventData);

  const nameValue = $form.find('[name="name"]').val();
  const phoneValue = $form.find('[name="phone"]').val();
  const emailValue = $form.find('[name="from"]').val();
  let subjectValue = $form.find('[name="subject"]').val();
  let contentValue = $form.find('[name="content"]').val();

  if (!subjectValue) {
    subjectValue = self._getMessageByLocale('defaultSubject');
  }

  if (fieldAgree.length && fieldAgree.prop('checked')) {
    contentValue += '<br /><br />' + self._getMessageByLocale('agreeEmailText');
  }

  let messageData = {
    name: nameValue,
    subject: subjectValue,
    content: contentValue,
    phone: phoneValue,
    from: emailValue,
    ...captchaResult.messageData
  };

  // Если поле сообщения пустое, и оно не является обязательным, то кладём в него дефолтный текст
  if (!contentValue) {
    messageData.content = self._getMessageByLocale('defaultContentText');
  }

  if (self.sending) {
    return;
  }

  window.EventBus.publish('before-send-feedback:insales:ui_feedback', eventData);

  self.sending = true;

  ajaxShop.message(messageData)
  .done(function() {
    $form.get(0).reset();

    if (successBlock.length) {
      successBlock.addClass(self.settings.classes.successShow);

      let showTime = self.settings.successShowTime;

      if (successBlock.data(self.options.formSuccess.data).showTime) {
        showTime = successBlock.data(self.options.formSuccess.data).showTime;
      }

      setTimeout(function() {
        successBlock.removeClass(self.settings.classes.successShow);
      }, showTime);
    }

    window.EventBus.publish('send-feedback:insales:ui_feedback', eventData);
    window.EventBus.publish('after-send-feedback:insales:ui_feedback', eventData);
  })
  .fail(function(onFail) {
    window.EventBus.publish('error-feedback:insales:ui_feedback', onFail);
    window.EventBus.publish('after-send-feedback:insales:ui_feedback', eventData);
    console.error('onFail: ', onFail);
  })
  .always(function() {
    self.sending = false;

    resetCaptcha({
      captchaType: self.captchaType,
      yandexCaptchaBlockSelector: self.options.formYandexCaptcha.attr,
      googleRecaptchaBlockSelector: self.options.formRecaptcha.attr,
      formType: 'feedback'
    });
  });
};

/**
 * Валидация всех полей формы перед отправкой
 * @method
 * @private
 * @param {jQuery} $form - форма
 * @returns {Object} - объект с ошибками валидации
 */
FeedbackDOM.prototype._validateForm = function($form) {
  const self = this;
  const fields = $form.find(self.options.formField.attr);
  const fieldAgree = $form.find(self.options.formFieldAgree.attr);
  const fieldRecaptcha = $form.find(self.options.formRecaptcha.attr);
  const fieldYandexCaptcha = $form.find(self.options.formYandexCaptcha.attr);
  const errors = {};

  const captchaResult = getCaptchaMessageData({
    captchaType: this.captchaType,
    form: $form.get(0),
    fieldRecaptcha: fieldRecaptcha.get(0),
    fieldYandexCaptcha: fieldYandexCaptcha.get(0),
    formType: 'feedback',
    callback: self._sendFeedbackForm.bind(self)
  });

  // Валидация обычных полей (исключая рекапчу)
  fields.not(self.options.formRecaptcha.attr).each(function() {
    const field = jquery(this);
    let fieldErrorMessage = field.data(self.options.formField.data).errorMessage || '';

    if (self._isValidField(field)) {
      self._removeFieldError(field);
    } else {
      self._addFieldError(field, fieldErrorMessage);
      if (field.attr('name')) {
        errors[field.attr('name')] = true;
      }
    }
  });

  // Валидация поля согласия
  if (fieldAgree.length) {
    if (fieldAgree.prop('checked') != true) {
      let fieldAgreeErrorMessage = fieldAgree.data(self.options.formFieldAgree.data).errorMessage || '';

      errors.field_agree = true;
      self._addFieldError(fieldAgree, fieldAgreeErrorMessage);
    } else {
      self._removeFieldError(fieldAgree);
    }
  }

  // Валидация капчи только для видимых типов
  if (captchaResult.captchaType === CAPTCHA_TYPE_GOOGLE && fieldRecaptcha.length) {
    const isInvisible = fieldRecaptcha.data('recaptchaType') === 'invisible';

    if (!isInvisible && captchaResult.status === 'missing') {
      const fieldRecaptchaErrorMessage = fieldRecaptcha.data(self.options.formRecaptcha.data).errorMessage || '';

      errors.recaptcha = true;
      self._addFieldError(fieldRecaptcha, fieldRecaptchaErrorMessage);
    } else if (captchaResult.status === 'success') {
      self._removeFieldError(fieldRecaptcha);
    }
  }

  if (captchaResult.captchaType === CAPTCHA_TYPE_YANDEX && fieldYandexCaptcha.length) {
    const isInvisible = fieldYandexCaptcha.data('yandexCaptchaType') === 'invisible';

    if (!isInvisible && captchaResult.status === 'missing') {
      const fieldYandexCaptchaErrorMessage = fieldYandexCaptcha.data(self.options.formYandexCaptcha.data).errorMessage || '';

      errors.yandex_captcha = true;
      self._addFieldError(fieldYandexCaptcha, fieldYandexCaptchaErrorMessage);
    } else if (captchaResult.status === 'success') {
      self._removeFieldError(fieldYandexCaptcha);
    }
  }

  return errors;
};

/**
 * Обработчик событий focus и blur для полей формы
 * @method
 * @private
 *
 * @returns {void}
 */
FeedbackDOM.prototype._bindFeedbackFormFieldActions = function() {
  const self = this;

  jquery(document).on('focus', `${self.options.form.attr} ${self.options.formField.attr}`, function() {
    self._removeFieldError(jquery(this));
  });

  jquery(document).on('blur', `${self.options.form.attr} ${self.options.formField.attr}`, function() {
    const field = jquery(this);
    let fieldErrorMessage = '';

    if (field.data(self.options.formField.data).errorMessage) {
      fieldErrorMessage = field.data(self.options.formField.data).errorMessage;
    }

    if (self._isValidField(field)) {
      self._removeFieldError(field);

      return;
    }

    self._addFieldError(field, fieldErrorMessage);
  });
};

/**
 * Обработчик для поля Agree
 * @method
 * @private
 *
 * @returns {void}
 */
FeedbackDOM.prototype._bindAgreeActions = function() {
  const self = this;

  jquery(document).on('change', `${self.options.form.attr} ${self.options.formFieldAgree.attr}`, function() {
    const fieldAgree = jquery(this);

    if (fieldAgree.prop('checked') != true) {
      self._addFieldError(fieldAgree, '');

      return;
    }

    self._removeFieldError(fieldAgree);
  });
};

/**
 * Обработчик для поля ReCaptcha.
 * Проверяет ответ рекапчи и добавляет или удаляет ошибку валидации.
 * @method
 * @private
 *
 * @returns {void}
 */
FeedbackDOM.prototype._bindRecaptchaActions = function() {
  const self = this;

  window.EventBus.subscribe('google-recaptcha:insales:response', function({ container: googleRecaptchaField }) {
    if (!googleRecaptchaField || !googleRecaptchaField.hasAttribute(self.options.formRecaptcha.data)) {
      return;
    }

    const tokenField = googleRecaptchaField.querySelector('[name="g-recaptcha-response"]') || googleRecaptchaField.querySelector('[name="feedback[g-recaptcha-response]"]');

    if (tokenField && tokenField.value) {
      self._removeFieldError(jquery(googleRecaptchaField));

      return;
    }

    const fieldOptions = JSON.parse(googleRecaptchaField.dataset[self.options.formRecaptcha.data]);

    let googleRecaptchaFieldError = fieldOptions.errorMessage || '';
    self._addFieldError(jquery(googleRecaptchaField), googleRecaptchaFieldError);
  });
};

/**
 * Обработчик для поля Yandex Captcha.
 * Проверяет ответ капчи и добавляет или удаляет ошибку валидации.
 * @method
 * @private
 * @param {Object} options - параметры для инициализации
 * @param {Object} options.container - контейнер для Yandex Captcha
 * @returns {void}
 */
FeedbackDOM.prototype._bindYandexCaptchaActions = function() {
  const self = this;

  window.EventBus.subscribe('yandex-captcha:insales:response', function({ container: yandexCaptchaField }) {
    if (!yandexCaptchaField || !yandexCaptchaField.hasAttribute(self.options.formYandexCaptcha.data)) {
      return;
    }

    const tokenField =
      yandexCaptchaField.querySelector('[name="yandex-smart-token"]')
      || yandexCaptchaField.querySelector('[name="feedback[yandex-smart-token]"]');

    if (tokenField && tokenField.value) {
      self._removeFieldError(jquery(yandexCaptchaField));

      return;
    }

    const fieldOptions = JSON.parse(yandexCaptchaField.dataset[self.options.formYandexCaptcha.data]);

    let yandexCaptchaFieldError = fieldOptions.errorMessage || '';
    self._addFieldError(jquery(yandexCaptchaField), yandexCaptchaFieldError);
  });
};

/**
 * Обработчик открытия формы в модальном окне
 * @method
 * @private
 *
 * @returns {void}
 */
FeedbackDOM.prototype._bindShowFeedbackModalForm = function() {
  const self = this;

  jquery(self.options.showModalForm.attr).on('click', function() {
    let modalId = 'default';

    if (jquery(this).data(self.options.showModalForm.data).modal_id) {
      modalId = jquery(this).data(self.options.showModalForm.data).modal_id;
    }

    const eventData = {
      button: jquery(this),
      modal_id: modalId
    };

    window.EventBus.publish('show-modal-feedback:insales:ui_feedback', eventData);
  });
};

/**
 * Добавление классов для обязательных полей
 * @method
 * @private
 *
 * @returns {void}
 */
FeedbackDOM.prototype._checkRequiredFields = function() {
  const self = this;

  jquery(self.options.formField.attr).each(function() {
    const feedbackField = jquery(this);

    if (self._isRequiredField(feedbackField)) { self._addFieldRequired(feedbackField); }
  });
};

/**
 * Проверка валидности поля
 * @method
 * @private
 *
 * @param {jQuery} fieldNode - поле формы
 * @returns {boolean} - валидно или нет
 */
FeedbackDOM.prototype._isValidField = function(fieldNode) {
  const self = this;
  let isValid = false;

  switch (fieldNode.attr('name')) {
    case 'phone':
      isValid = !!self._isValidPhone(fieldNode);
      break;
    case 'from':
      isValid = !!self._isValidEmail(fieldNode);
      break;
    case 'content':
      isValid = !!self._isValidContent(fieldNode);
      break;
    case 'name':
      isValid = !!self._isValidName(fieldNode);
      break;
    case 'subject':
      isValid = !!self._isValidSubject(fieldNode);
      break;
    default:
  }

  return isValid;
};

/**
 * Проверка обязательности поля
 * @method
 * @private
 *
 * @param {jQuery} fieldNode - поле формы
 *
 * @returns {boolean} - обязательное или нет
 */
FeedbackDOM.prototype._isRequiredField = function(fieldNode) {
  const self = this;

  if (!fieldNode.attr('name')) { return; }

  let isRequired = false;

  if (fieldNode.attr('name') === 'phone') { isRequired = self.settings.phoneRequired; }
  if (fieldNode.attr('name') === 'name') { isRequired = self.settings.nameRequired; }
  if (fieldNode.attr('name') === 'subject') { isRequired = self.settings.subjectRequired; }
  if (fieldNode.attr('name') === 'from') { isRequired = self.settings.fromRequired; }
  if (fieldNode.attr('name') === 'content') { isRequired = self.settings.contentRequired; }

  if (fieldNode.data(self.options.formField.data) && fieldNode.data(self.options.formField.data).isRequired) {
    isRequired = fieldNode.data(self.options.formField.data).isRequired;
  }

  return isRequired;
};

/**
 * Проверка валидности поля - Телефон (phone)
 * @method
 * @private
 *
 * @param {jQuery} phoneNode - поле формы
 * @returns {boolean} - валидно или нет
 */
FeedbackDOM.prototype._isValidPhone = function(phoneNode) {
  const self = this;

  const phoneValue = phoneNode.val();
  const phoneNumberLengthSecond = self.settings.phoneNumberLengthSecond;
  let isPhoneRequired = self.settings.phoneRequired;
  let phoneNumberLength = self.settings.phoneNumberLength;

  if (phoneNode.data(self.options.formField.data) && phoneNode.data(self.options.formField.data).isRequired) {
    isPhoneRequired = phoneNode.data(self.options.formField.data).isRequired;
  }

  if (phoneNode.data(self.options.formField.data) && phoneNode.data(self.options.formField.data).phoneNumberLength) {
    phoneNumberLength = phoneNode.data(self.options.formField.data).phoneNumberLength;
  }

  if (phoneNumberLength === 'any') {
    if (isPhoneRequired && !phoneNode.val().trim()) { return false; }

    return true;
  } else if (self._getPhoneNumberLength(phoneValue) === parseInt(phoneNumberLength)
    || self._getPhoneNumberLength(phoneValue) === parseInt(phoneNumberLengthSecond)) {
    return true;
  }

  if (isPhoneRequired) {
    return false;
  } else if (!phoneNode.val().trim()) {
    return true;
  }
};

/**
 * Проверка валидности поля - E-mail (from)
 * @method
 * @private
 *
 * @param {jQuery} emailNode - поле формы
 * @returns {boolean} - валидно или нет
 */
FeedbackDOM.prototype._isValidEmail = function(emailNode) {
  const self = this;

  const emailValue = emailNode.val();
  let isEmailRequired = self.settings.fromRequired;

  if (emailNode.data(self.options.formField.data) && !emailNode.data(self.options.formField.data).isRequired) {
    isEmailRequired = emailNode.data(self.options.formField.data).isRequired;
  }

  if (isEmailRequired) {
    return !!((emailValue.trim() && self._emailTest(emailValue)));
  }

  if (emailValue.trim() && self._emailTest(emailValue)) {
    return true;
  }

  return emailValue.trim() === '';
};

/**
 * Проверка валидности поля - Текста сообщения (content)
 * @method
 * @private
 *
 * @param {jQuery} contentNode - поле формы
 * @returns {boolean} - валидно или нет
 */
FeedbackDOM.prototype._isValidContent = function(contentNode) {
  const self = this;

  const contentValue = contentNode.val();
  let isContentRequired = self.settings.contentRequired;

  if (contentNode.data(self.options.formField.data) && contentNode.data(self.options.formField.data).isRequired) {
    isContentRequired = contentNode.data(self.options.formField.data).isRequired;
  }

  return !((isContentRequired && !contentValue.trim()));
};

/**
 * Проверка валидности поля - Имя (name)
 * @method
 * @private
 *
 * @param {jQuery} nameNode - поле формы
 * @returns {boolean} - валидно или нет
 */
FeedbackDOM.prototype._isValidName = function(nameNode) {
  const self = this;

  const nameValue = nameNode.val();
  let isNameRequired = self.settings.nameRequired;

  if (nameNode.data(self.options.formField.data) && nameNode.data(self.options.formField.data).isRequired) {
    isNameRequired = nameNode.data(self.options.formField.data).isRequired;
  }

  return !((isNameRequired && !nameValue.trim()));
};

/**
 * Проверка валидности поля - Тема сообщения (subject)
 * @method
 * @private
 *
 * @param {jQuery} subjectNode - поле формы
 * @returns {boolean} - валидно или нет
 */
FeedbackDOM.prototype._isValidSubject = function(subjectNode) {
  const self = this;

  const subjectValue = subjectNode.val();
  let isSubjectRequired = self.settings.subjectRequired;

  if (subjectNode.data(self.options.formField.data) && subjectNode.data(self.options.formField.data).isRequired) {
    isSubjectRequired = subjectNode.data(self.options.formField.data).isRequired;
  }

  return !((isSubjectRequired && !subjectValue.trim()));
};

/**
 * Количество цифр в поле телефона
 * @method
 * @private
 *
 * @param {string} phone - телефон
 * @returns {number} - количество цифр
 */
FeedbackDOM.prototype._getPhoneNumberLength = function(phone) {
  const VRegExp = new RegExp(/[\d]/g);
  let VResult = phone.match(VRegExp);
  if (!VResult) {
    VResult = [];
  }

  return VResult.length;
};

/**
 * Проверка валидности email адресов
 * @method
 * @private
 *
 * @param {string} email - email
 * @returns {boolean} - валидно или нет
 */
FeedbackDOM.prototype._emailTest = function(email) {
  const VRegExp = new RegExp(/.+@.+\..+/g);
  const VResult = VRegExp.test(email);

  return VResult;
};

/**
 * Добавление специальных css-классов для поля с ошибкой
 * @method
 * @private
 *
 * @param {jQuery} fieldNode - поле формы
 * @param {string} errorMessage - текст ошибки
 * @returns {void}
 */
FeedbackDOM.prototype._addFieldError = function(fieldNode, errorMessage) {
  const self = this;

  const errorBlock = fieldNode.parents(self.options.formFieldArea.attr).find(self.options.formFieldError.attr);

  fieldNode.addClass(self.settings.classes.isError);
  fieldNode.parents(self.options.formFieldArea.attr).addClass(self.settings.classes.isError);

  if (errorBlock && errorMessage) {
    errorBlock.html(errorMessage);
  }
};

/**
 * Удаление специальных css-классов для поля с ошибкой
 * @method
 * @private
 *
 * @param {jQuery} fieldNode - поле формы
 * @returns {void}
 */
FeedbackDOM.prototype._removeFieldError = function(fieldNode) {
  const self = this;

  const errorBlock = fieldNode.parents(self.options.formFieldArea.attr).find(self.options.formFieldError.attr);

  fieldNode.removeClass(self.settings.classes.isError);
  fieldNode.parents(self.options.formFieldArea.attr).removeClass(self.settings.classes.isError);

  if (errorBlock) { errorBlock.html(''); }
};

/**
 * Добавление специальных css-классов для обязательного поля
 * @method
 * @private
 *
 * @param {jQuery} fieldNode - поле формы
 * @returns {void}
 */
FeedbackDOM.prototype._addFieldRequired = function(fieldNode) {
  const self = this;

  fieldNode.addClass(self.settings.classes.isRequired);
  fieldNode.parents(self.options.formFieldArea.attr).addClass(self.settings.classes.isRequired);
};

/**
 * @private
 *
 * @description
 * Получение текста из словаря базовых настроек
 *
 * @param {string} messageName - название свойства в словаре
 * @returns {string} - текст сообщения
 */
FeedbackDOM.prototype._getMessageByLocale = function(messageName) {
  const self = this;

  if (typeof self.locale !== 'undefined') {
    let resultMessage = self.settings[messageName][self.locale];

    if (typeof resultMessage === 'undefined') {
      resultMessage = self.settings[messageName].ru;
    }

    return resultMessage;
  }

  return self.settings[messageName].ru;
};

export default _Singleton(FeedbackDOM).getInstance();
